import { useId, type ReactNode } from "react";
import { Dialog, DialogContent, DialogTitle, IconButton } from "@mui/material";
import { Close } from "@mui/icons-material";

// large: quase tela cheia, pra conteúdo largo (grades, relatórios); medium: tabela
// ou lista com filtros, que não precisa da tela toda.
const TAMANHOS = {
  large: { width: "min(1800px, 96vw)", height: "94vh" },
  medium: { width: "min(1100px, 96vw)", height: "80vh" },
} as const;

interface LargeDialogProps {
  open: boolean;
  title: string;
  onClose: () => void;
  size?: keyof typeof TAMANHOS;
  children: ReactNode;
}

// Dialog de altura fixa pra conteúdo largo. O conteúdo preenche a altura: quem
// precisa rolar por dentro usa flex: 1 e minHeight: 0.
export function LargeDialog({ open, title, onClose, size = "large", children }: LargeDialogProps) {
  const { width, height } = TAMANHOS[size];
  const titleId = useId();
  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth={false}
      aria-labelledby={titleId}
      slotProps={{ paper: { sx: { width, height, maxHeight: height, borderRadius: 3 } } }}
    >
      <DialogTitle id={titleId} sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", pr: 1 }}>
        {title}
        <IconButton aria-label="Fechar" onClick={onClose}>
          <Close />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers sx={{ display: "flex", flexDirection: "column", minHeight: 0 }}>
        {children}
      </DialogContent>
    </Dialog>
  );
}
